import { Fragment, useEffect, useState } from "react";
import { useDownloadPDF, useOptionListInit, useProfitDate, useProfitGridLoad } from "./store/ProfitHook";
import { ElementGroup, LeftTableContainer, TableContainer, Title } from "styles/components";
import styled from "styled-components";
import { UiSelectBox } from "components/ui/SelectBox";
import { useDispatch } from "react-redux";
import { rdxSetProfitActiveTab } from "./store/ProfitR";
import type { IGridSetting, IGrideCell } from "commons/ui/grid/GridVo";
import { ButtonColor, ButtonSize } from "components/ComponentsType";
import Button from "components/ui/Button";
import { usePaymentPopup } from "components/popup/payment/PaymentPopupHook";
import { LoadingContainer } from "pages/statistics/Statistics";
import Spinner from "components/ui/Spinner";
import { LazyProfitChart } from ".";
import type { IProfitContentData, IProfitGridVo, ProfitTabType } from "./store/ProfitVo";
import NotFound from "pages/404";
import { useLocation } from "react-router-dom";
import { numberComma } from "pages/calculate/components/manage";
import { payStatus } from "pages/calculate/store/CalculateVo";
import { useTranslation } from "react-i18next";
import ReadyPage from "pages/ReadyPage";

const SubTitle = styled.p`
  font-size: 1.14rem;
  font-weight: 600;
  color: #161c1c;
  margin-bottom: 16px;
`;
const TabBtnWrapper = styled.div`
  width: 100%;
  display: flex;
  button {
    width: 250px;
    height: 40px;
    font-weight: 500;
    font-size: 1.05rem;
    border-width: 1px;
    padding: 0;
  }
`;
const TabContainer = styled(ElementGroup.Row)`
  width: 100%;
  li {
    margin-left: 10px;
    button {
      border: none;
      width: 120px;
      height: 44px;
      border-radius: 100px;
      background: #f0f0f0;
      color: #000;
      font-weight: 500;
      &.is-active {
        color: #fff;
        background-color: var(--primary);
        font-weight: 500;
      }
      span {
        display: none;
      }
    }
  }
`;
const ContentsGridContainer = styled.div<{ isLoading: boolean }>`
  position: relative;
  width: 100%;
  height: auto;
  margin-top: 30px;
  .grid-wrapper {
    > p {
      text-align: center;
      margin: 20px 0;
      color: #dedede;
    }
  }

  #ProfitPayment table tbody tr {
    /* td:nth-child(2) {
      color: var(--primary);
    } */
    td:nth-child(2) {
      color: var(--font-red);
    }
  }
`;
const ElementRroupWrap = styled(ElementGroup.Row)`
  margin-bottom: 14px;
`;
const PaymentTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  width: 100%;
  margin-top: 20px;
  font-size: 1.05rem;
  line-height: 1.7rem;
  color: #444;
  .payment-info__div {
    p {
      /* color: red; */
      color: #268271;
      font-size: 1.15rem;
      font-weight: 700;
      margin-bottom: 8px;
    }
    li {
      font-size: 1rem;
      &.payment-notice {
        color: var(--primary);
        font-weight: 500;
      }
      &:nth-child(4) {
        margin-bottom: 5px;
      }
      &::before {
        content: "•";
        margin-right: 5px;
      }
    }
  }
`;

const OptionContainer = styled(ElementGroup.Col)`
  align-items: baseline;
  > div:first-child {
    .channel-select-items div {
      background-color: var(--primary);
      font-size: 0.95rem;
      margin-right: 3px;
    }
  }
  > div:last-child {
    > div:last-child p label {
      width: 78px;
      border-radius: 3px;
      font-size: 1rem;
      line-height: 30px;
      height: 34px;
    }
  }
`;

const PaymentGridCell = styled.div`
  button {
    color: #888;
    border-radius: 2px;
    &:hover {
      color: #222;
      text-decoration: underline;
      text-underline-position: under;
    }
  }
`;
const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;

  p.title {
    margin-bottom: 25px;
  }
  button {
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid var(--border-normal);
    color: #444;
    font-size: 1rem;
  }
`;

const ProfitDetailStyled = styled.div`
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--border-normal);
  padding: 20px;

  .profit-detail-option {
    > div {
      &:first-child {
        margin-right: 10px;
      }
    }
  }
`;

const ProfitFooterStyled = styled.div`
  position: relative;
  width: 100%;
  margin: 20px 0;
  padding: 20px;
  border: 1px solid var(--border-normal);
  border-radius: 8px;

  .download-btn {
    position: absolute;
    margin-top: 16px;
    right: 20px;
    top: 0;
    font-size: 1rem;
    border-radius: 8px;
    color: #444;
    background-color: #fff;
    border: 1px solid var(--border-normal);
  }
  > div {
    h3 {
      font-size: 1.15rem;
      margin-bottom: 16px;
      font-weight: 600;
    }

    &.profit-tax {
      .profit-tax-detail {
        display: flex;
        font-size: 1.13rem;
        font-weight: 500;
        width: 100%;
        gap: 50px;

        > div {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 1.05rem;

          p:first-child {
            color: #7c8484;
          }
          p:last-child {
            color: #1079f4;
            font-weight: 500;
          }
        }
      }
    }

    &.profit-info {
      margin-top: 20px;
      width: 100%;
      background-color: #f7f9f9;
      border-radius: 6px;
      padding: 15px 20px;
      ul {
        padding: 0 20px;
        list-style: disc;
        li {
          /* display: flex;
          align-items: center; */
          margin-bottom: 2px;
          font-size: 1rem;
          color: #7c8484;

          &.blue {
            /* color: var(--secondary); */
            color: #1079f4;
          }

          &.red {
            color: #ff0000;
          }

          &.black {
            color: #222;
          }
        }
      }

      .profit-info-btn {
        border: 1px solid #bebebe;
        font-size: 0.9rem;
        margin-left: 6px;
      }
    }
  }
`;

const ProfitDetailContentStyled = styled.div<{ width: number }>`
  display: flex;
  width: 100%;
  margin-top: 16px;
  border-radius: 8px;
  gap: 14px;
  div.profit-total-wrapper {
    position: relative;
    width: ${props => `${props.width}%`};
    padding: 40px 20px;
    border-radius: 8px;
    border: 1px solid var(--border-normal);
    div.header {
      position: relative;
      /* display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: end; */
      .title {
        font-size: 1.1rem;
        color: #444444;
        margin-bottom: 15px;
      }
      .total {
        color: #161c1c;
        font-weight: 700;
        font-size: 2rem;
      }
      .media-ratio {
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    div.content {
      margin-top: 35px;
      progress {
        width: 100%;
        height: 8px;
        margin: 0;
        appearance: none;
        -webkit-appearance: none;

        &::-webkit-progress-bar {
          /* progressbar의 배경이 되는 요소 */
          border-radius: 10px;
          background-color: var(--secondary);
        }

        &::-webkit-progress-value {
          /* progress의 진행 bar가 되는 요소 */
          border-radius: 10px;
          background-color: var(--primary);
        }
      }
      div.detail {
        margin-top: 30px;
        div {
          display: flex;
          justify-content: space-between;

          p {
            color: #444;
            font-size: 1.1rem;
            &:first-child {
              margin-bottom: 14px;
              &.viewus {
                &::before {
                  background-color: var(--primary);
                }
              }
              &.msn {
                &::before {
                  background-color: var(--secondary);
                }
              }
              &::before {
                content: "";
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                margin-right: 5px;
              }
            }
            &:last-child {
              font-weight: 600;
              color: #444;
            }
          }
        }
      }
    }
  }

  div.profit-comparison-wrapper {
    width: ${props => `${100 - props.width}%`};
    background-color: #f7f9f9;
    border-radius: 12px;
    padding: 14px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .comparison-div {
      flex: 1 1 auto;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      padding: 16px 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        p.sub {
          font-size: 1rem;
          color: #7c8484;
        }
        p.amount {
          color: #161c1c;
          font-size: 1.5rem;
          font-weight: 700;
        }
      }
    }
  }
`;

const RatioStyled = styled.p<{ type: string }>`
  display: flex;
  align-items: center;
  font-size: 1rem;
  padding: 2px 14px;
  border-radius: 4px;
  background-color: #f1f1f1;
  font-weight: 500;

  ${props =>
    props.type === "up"
      ? `    background-color: #e7f3ff;
    padding: 2px 8px;
    color: #007fff;
    &::before {
      content: "▲";
      display: inline-block;
      width: 14px;
      font-size: 0.6rem;
    }`
      : props.type === "down"
      ? `    background-color: #ffefef;
    padding: 2px 8px;
    color: #ed5151;
    &::before {
      content: "▼";
      display: inline-block;
      font-size: 0.6rem;
      width: 14px;
    }`
      : ""};
`;

const ListGridContainer = styled.div<{ gridNum: number }>`
  width: 100%;

  > p.empty {
    margin: 20px 0;
    color: #7c8484;
    padding: 20px;
    text-align: center;
  }
  div.grid {
    display: grid;
    grid-template-columns: repeat(${props => props.gridNum}, 1fr);
    &.content {
      padding: 16px 15px;
    }

    &.header {
      padding: 10px 15px;
      border-radius: 8px;
      background-color: #f7f9f9;
      border-bottom: 1px solid var(--border-normal);
      div {
        font-size: 1rem;
        color: #7c8484;
        font-weight: 500;
      }
    }
  }
`;

const GridContentRow = styled.div`
  border-bottom: 1px solid var(--border-normal);

  .date-column {
    display: flex;
    align-items: center;
    gap: 5px;
    span {
      font-size: 0.94rem;
      color: #888;
    }
  }
  .toggle {
    display: flex;
    justify-content: end;
    text-align: right;
    &.close {
      button {
        transform: rotate(180deg);
        margin-right: 5px;
      }
    }
  }

  .sub {
    background-color: #f9fafc;
    padding: 16px 15px;
    div {
      font-size: 0.98rem;
      color: #444;
    }
  }
`;

const PayStatusStyled = styled.div<{ type?: string }>`
  p {
    background-color: #fff;
    color: ${props => (props.type === payStatus.ok ? "#1079F4" : "#E65F3E")};
    border: 1px solid #dedede;
    border-radius: 4px;
    padding: 3px 8px;
    width: 70px;
    text-align: center;
    white-space: nowrap;
  }
`;

const GridToggleContaier = styled.div<{ isToggled: boolean }>`
  border-top: 2px solid var(--border-normal);
  display: ${props => (props.isToggled === true ? `block` : `none`)};
`;

const MonthCalculate = (val: string | number, type: string) => {
  const month = Number(val);
  const num = type === "msn" ? 3 : 2;
  return month - num < 1 ? `${month + (12 - num)}월` : `${month - num}월`;
};
const statusText = (status: payStatus) => {
  if (status === payStatus.ok) {
    return "지급완료";
  } else {
    return "미지급";
  }
};
export function NowYearSelectBox() {
  const now = new Date();
  const year = now.getFullYear();
  const yearData = [];
  for (let i = 2023; i < year + 1; i++) {
    yearData.push({ id: `${i}`, text: `${i}년`, value: `${i}` });
  }

  return { year, yearData };
}

export function NowMonthSelectBox() {
  const now = new Date();
  const now_month = now.getMonth() + 1;
  const month_list = [];
  for (let i = 1; i <= 12; i++) {
    month_list.push({ id: `${i}`, text: `${i}월`, value: `${i}` });
  }

  return { now_month, month_list };
}

/**
 * 지급 탭 - 세액
 */
function GridTaxCell(props: IGrideCell<[number]>) {
  const tax = Math.floor(props.data[0] * 0.1);
  return <p>{tax.toLocaleString("ko-kr")}</p>;
}
/**
 * 지급 탭 - 토탈
 */
function GridTotalCell(props: IGrideCell<[number]>) {
  const total = props.data[0] + Math.floor(props.data[0] * 0.1);
  return <p>{total.toLocaleString("ko-kr")}</p>;
}

/**
 * 지급 탭 - 그리드 > 상세 내역
 * @param props 페이지뷰
 * @returns
 */
function GridPaymentDetailCell(props: IGrideCell<[number]>) {
  const { showPaymentPopup } = usePaymentPopup();
  return (
    <PaymentGridCell>
      <Button
        btnType="ghost"
        color={ButtonColor.DARK}
        btnSize={ButtonSize.XSM}
        text="서비스 상세 내역"
        onClick={() => showPaymentPopup(props.data[0])}
      />
    </PaymentGridCell>
  );
}

function ProfitSearchOption(props: { tab: string }): JSX.Element {
  const dispatch = useDispatch();
  // const { tab, selectChannel, optionList } = useOptionListInit();

  return (
    <OptionContainer>
      <UiSelectBox
        id={"profit_year_date"}
        data={NowYearSelectBox().yearData}
        selectId="value"
        selectType="id"
        size="xmd"
        displayType="new"
        init={String(NowYearSelectBox().year)}
      />
    </OptionContainer>
  );
}

/**
 * 수익 내역 > 수익 합계, 상세 데이터
 */
function ProfitDetailContent(props: { tab: string; data?: IProfitContentData }) {
  const { year, month } = useProfitDate();

  const ratioCheck = (number: number) => {
    if (number > 0) {
      return "up";
    } else if (number < 0) {
      return "down";
    } else {
      return "none";
    }
  };
  return (
    props.data && (
      <ProfitDetailContentStyled width={props.tab === "PROVIDER" ? 62 : 100}>
        <div className="profit-total-wrapper">
          <div className="header">
            <p className="title">{`${year}년 ${month ? `${month}월 ` : ""}`}수익 합계</p>
            <p className="total">{numberComma(props.data.total)}원</p>
            {props.tab === "MEDIA" && (
              <div className="media-ratio">
                <RatioStyled type={ratioCheck(props.data.revenue_ratio)}>
                  {props.data.revenue_ratio === 0 ? "-" : `${numberComma(props.data.revenue_ratio)}%`}
                </RatioStyled>
              </div>
            )}
          </div>

          <div className="content">
            <progress
              max={props.tab === "PROVIDER" ? props.data.total : 100}
              value={props.tab === "PROVIDER" ? props.data.revenue : 100}
              className="bar-progress"
            />
            <div className="detail">
              <div className="viewus">
                <p className="viewus">{props.tab === "PROVIDER" ? "뷰어스" : "유튜브"}</p>
                <p>{numberComma(props.data.revenue)}원</p>
              </div>
              {props.tab === "PROVIDER" && (
                <div className="msn">
                  <p className="msn">MSN</p>
                  <p>{numberComma(props.data.msn_revenue ? props.data.msn_revenue : 0)}원</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {props.tab === "PROVIDER" && (
          <div className="profit-comparison-wrapper">
            <div className="comparison-div">
              <div>
                <p className="sub">뷰어스</p>
                <RatioStyled type={ratioCheck(props.data.revenue_ratio)}>
                  {props.data.revenue_ratio === 0 ? "-" : `${numberComma(props.data.revenue_ratio)}%`}
                </RatioStyled>
              </div>
              <div>
                <p className="amount">{numberComma(props.data.revenue)}원</p>
                <p className="sub">{month ? MonthCalculate(month, "viewus") : "전체"} 정산분</p>
              </div>
            </div>

            <div className="comparison-div">
              <div>
                <p className="sub">MSN</p>
                <RatioStyled type={ratioCheck(props.data.msn_ratio ? props.data.msn_ratio : 0)}>
                  {props.data.msn_ratio === 0
                    ? "-"
                    : `${numberComma(props.data.msn_ratio ? props.data.msn_ratio : 0)}%`}
                </RatioStyled>
              </div>
              <div>
                <p className="amount">{numberComma(props.data.msn_revenue ? props.data.msn_revenue : 0)}원</p>
                <p className="sub">{month ? MonthCalculate(month, "msn") : "전체"} 정산분</p>
              </div>
            </div>

            <div className="comparison-div">
              <div>
                <p className="sub">합계</p>
                <RatioStyled type={ratioCheck(props.data.total_ratio)}>
                  {props.data.total_ratio === 0 ? "-" : `${numberComma(props.data.total_ratio)}%`}
                </RatioStyled>
              </div>
              <div>
                <p className="amount">{numberComma(props.data.total)}원</p>
              </div>
            </div>
          </div>
        )}
      </ProfitDetailContentStyled>
    )
  );
}

function ProfitProviderGridContentRow(props: {
  data: IProfitGridVo;
  serviceList: { id: string; text: string }[];
  isToggled: boolean;
  onToggle: () => void;
}): JSX.Element {
  const item = props.data;
  return (
    <GridContentRow>
      <div className="grid content all">
        <div className="date-column">{item.date}</div>
        <div>{"전체"}</div>
        <div>{numberComma(item.total)}원</div>
        <div>{numberComma(item.total_tax)}원</div>
        <div>{numberComma(item.total + item.total_tax)}원</div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {item.total_pay_status ? (
            <PayStatusStyled type={item.total_pay_status}>
              <p>{statusText(item.total_pay_status)}</p>
            </PayStatusStyled>
          ) : (
            <div></div>
          )}
          <div className={`toggle ${props.isToggled === true ? "close" : "open"}`}>
            <Button
              btnSize="sm"
              iconName={"DownArrow"}
              iconPosition="before"
              btnType="ghost"
              text=""
              onClick={props.onToggle}
            ></Button>
          </div>
        </div>
      </div>
      <GridToggleContaier isToggled={props.isToggled}>
        {props.serviceList.map((service, idx) => {
          const revenue =
            service.id === "msn" ? (item.msn_revenue ? item.msn_revenue : 0) : item.revenue ? item.revenue : 0;
          return (
            Math.floor(revenue + revenue * 0.1) > 0 && (
              <div key={idx} className="grid sub">
                <div className="date-column">
                  <span>발생월</span>
                  {MonthCalculate(item.date.substring(5, 8), service.id)}
                </div>
                <div>{service.text}</div>
                <div>{numberComma(revenue)}원</div>
                <div>{numberComma(Math.floor(revenue * 0.1))}원</div>
                <div>{numberComma(Math.floor(revenue + revenue * 0.1))}원</div>
                <PayStatusStyled type={service.id === "msn" ? item.msn_pay_status : item.pay_status}>
                  <p>{service.id === "msn" ? statusText(item.msn_pay_status!) : statusText(item.pay_status)}</p>
                </PayStatusStyled>
              </div>
            )
          );
        })}
      </GridToggleContaier>
    </GridContentRow>
  );
}
function ProfitProviderContentsGrid(props: { tab: string; isLoading?: boolean; list?: IProfitGridVo[] }): JSX.Element {
  const list = props.list && props.list.length > 0 ? props.list : [];
  const serviceList = [
    { id: "viewus", text: "뷰어스" },
    { id: "msn", text: "MSN" },
  ];

  const [toggledIndexes, setToggledIndexes] = useState(Array(list.length).fill(false));

  const handleToggle = (index: number) => {
    const newToggledIndexes = [...toggledIndexes];
    newToggledIndexes[index] = !newToggledIndexes[index];
    setToggledIndexes(newToggledIndexes);
  };
  return (
    <ContentsGridContainer isLoading={false}>
      {props.isLoading && (
        <LoadingContainer>
          <Spinner size={86} />
        </LoadingContainer>
      )}

      <ListGridContainer gridNum={6}>
        <div className="grid header">
          <div>날짜(정산월)</div>
          <div>서비스(품목명)</div>
          <div>공급가</div>
          <div>세액</div>
          <div>합계</div>
          <div>지급여부</div>
        </div>
        {list.length > 0 ? (
          <div className="list-wrap">
            {list.map((item, index) => {
              return (
                <ProfitProviderGridContentRow
                  key={index}
                  data={item}
                  serviceList={serviceList}
                  isToggled={toggledIndexes[index]}
                  onToggle={() => handleToggle(index)}
                />
              );
            })}
          </div>
        ) : (
          <p className="empty">데이터가 없습니다.</p>
        )}
      </ListGridContainer>
    </ContentsGridContainer>
  );
}

function ProfitMediaContentsGrid(props: { tab: string; isLoading?: boolean; list?: IProfitGridVo[] }): JSX.Element {
  const list = props.list && props.list.length > 0 ? props.list : [];

  return (
    <ContentsGridContainer isLoading={false}>
      {props.isLoading && (
        <LoadingContainer>
          <Spinner size={86} />
        </LoadingContainer>
      )}

      {/* <ListGridContainer gridNum={props.tab !== "PARTNERS" ? 6 : 5}> */}
      <ListGridContainer gridNum={5}>
        <div className="grid header">
          <div>정산월</div>
          <div>발생월</div>
          <div>공급가</div>
          <div>세액</div>
          <div>합계</div>
          {/* {props.tab !== "PARTNERS" && <div>지급여부</div>} */}
        </div>
        {list.length > 0 ? (
          <div className="list-wrap">
            {list.map((item, index) => {
              return (
                <GridContentRow key={index}>
                  <div className="grid content all">
                    <div>{item.date}</div>
                    <div>{MonthCalculate(item.date.substring(5, 8), "media")}</div>
                    <div>{numberComma(item.total)}원</div>
                    <div>{numberComma(Math.floor(item.total * 0.1))}원</div>
                    <div>{numberComma(Math.floor(item.total + item.total * 0.1))}원</div>
                    {/* {props.tab !== "PARTNERS" && (
                      <PayStatusStyled className="pay_status" type={item.pay_status}>
                        <p>{statusText(item.pay_status)}</p>
                      </PayStatusStyled>
                    )} */}
                  </div>
                </GridContentRow>
              );
            })}
          </div>
        ) : (
          <p className="empty">데이터가 없습니다.</p>
        )}
      </ListGridContainer>
    </ContentsGridContainer>
  );
}

function ProfitContents(props: { tab: string }) {
  const { isLoading, profitInfo } = useProfitGridLoad(props.tab);

  return (
    <>
      <ProfitDetailStyled>
        <SubTitle>수익 내역</SubTitle>
        <div className="profit-detail-option">
          <UiSelectBox
            id={"profit_detail_year"}
            data={NowYearSelectBox().yearData}
            selectId="value"
            selectType="id"
            size="xmd"
            displayType="new"
            init={String(NowYearSelectBox().year)}
          />
          <UiSelectBox
            id={"profit_detail_month"}
            data={[{ id: 0, text: "전체", value: "0" }, ...NowMonthSelectBox().month_list]}
            selectId="value"
            selectType="id"
            size="sm"
            displayType="new"
            init={"0"}
          />
        </div>

        {/* 수익 내역 */}
        {props.tab !== "PARTNERS" && <ProfitDetailContent tab={props.tab} data={profitInfo} />}

        {/* 수익 데이터 리스트 */}
        {props.tab === "PROVIDER" ? (
          <ProfitProviderContentsGrid tab={props.tab} isLoading={isLoading} list={profitInfo?.list} />
        ) : props.tab === "MEDIA" ? (
          <ProfitMediaContentsGrid tab={props.tab} isLoading={isLoading} list={profitInfo?.list} />
        ) : (
          <ProfitMediaContentsGrid tab={props.tab} isLoading={isLoading} list={profitInfo?.list} />
        )}
      </ProfitDetailStyled>
    </>
  );
}
function ProfitTabComponent(props: { tab: string }) {
  return (
    <>
      <ElementRroupWrap>
        <ProfitSearchOption tab={props.tab} />
      </ElementRroupWrap>
      {/* 수익 차트 */}
      <LazyProfitChart />
      <ProfitContents tab={props.tab} />
    </>
  );
}

function ProfitFooter(props: { tab: string }) {
  const list = [
    { title: "수익 확정일", content: "매월 20일" },
    { title: "세금계산서 역발행기간", content: "매월 20일~27일" },
    { title: "승인 마감일", content: "매월 28일" },
    { title: "정산 지급일", content: "매월 말일" },
    // { title: "발행 대상", content: "support@fastviewkorea.com" },
  ];

  const goToUnipostList = () => {
    window.open("https://drive.google.com/file/d/1kh9yrrod88lLZBmmYYwqtm3x1yCepPRh/view");
  };
  return (
    <ProfitFooterStyled>
      <Button
        btnSize="sm"
        color={"dark"}
        btnType="border"
        iconName="Download"
        iconPosition="before"
        text="사업자등록증 받기"
        className="download-btn"
        onClick={() => useDownloadPDF()}
      ></Button>
      <div className="profit-tax">
        <SubTitle>세금계산서 발행</SubTitle>
        <div className="profit-tax-detail">
          {list.map(i => {
            return (
              <div key={i.title}>
                <p>{i.title}</p>
                <p>{i.content}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="profit-info">
        <SubTitle>안내사항</SubTitle>
        <ul>
          <li className="red">
            유니포스트 서비스 최초 1회 가입이 필요합니다.
            <Button
              btnSize="xs"
              color={"dark"}
              btnType="border"
              text="서비스 메뉴얼 안내"
              radius={6}
              className="profit-info-btn"
              onClick={() => goToUnipostList()}
            />
          </li>
          <li>역세금계산서 발행 절차 : 프로필란 &apos;세금계산서 발행&apos; 메일 주소로 자동 발송됩니다.</li>
          <li>세금계산서 미승인 시, 정산 지급이 익월로 미뤄집니다.</li>
          <li>수익 확정일이 주말/공휴일인 경우, 이전 영업일에 발행됩니다.</li>
          <li>세금계산서 승인 마감일이 주말/공휴일일 경우 마감일은 이전 영업일로 변경됩니다.</li>
          <li>사업자가 아닌 개인인 경우, 사업소득으로 신고가 되며 소득세 3.3% 제외 후 지급됩니다.</li>
          {props.tab === "PROVIDER" ? (
            <li className="black">월(M) 서비스의 수익은 MSN 콘텐츠는 M+3 / 뷰어스 콘텐츠는 M+2 에 정산됩니다.</li>
          ) : (
            <li className="black">월(M) 서비스의 수익은 M+2 에 정산됩니다.</li>
          )}
        </ul>
      </div>
    </ProfitFooterStyled>
  );
}
function ProfitComponent(props: { tab: ProfitTabType }) {
  const { t } = useTranslation();
  return (
    <>
      <HeaderWrap>
        <Title size="lg" weight="medium">
          {t("nav.LNB.revenue")}
        </Title>
      </HeaderWrap>

      <ProfitFooter tab={props.tab} />
      <ProfitTabComponent tab={props.tab} />
    </>
  );
}
/**
 * 통계 페이지
 * @returns JSX.Element
 */
export function ProfitPages(): JSX.Element {
  const dispatch = useDispatch();
  const location = useLocation();

  const path = location.pathname.split("/");
  const tab = path[2].toLocaleUpperCase() as ProfitTabType;

  const { i18n } = useTranslation();

  useEffect(() => {
    if (tab === "PROVIDER" || tab === "MEDIA" || tab === "PARTNERS") {
      dispatch(rdxSetProfitActiveTab(path[2].toLocaleUpperCase() as ProfitTabType));
    }
  }, [tab]);

  return (
    <Fragment>
      {i18n.language !== "en" ? (
        tab === "PROVIDER" || tab === "MEDIA" || tab === "PARTNERS" ? (
          <ProfitComponent tab={tab} />
        ) : (
          <NotFound />
        )
      ) : (
        <ReadyPage />
      )}
    </Fragment>
  );
}

export default ProfitPages;
